import { Colors, Services, integerMaskOptions } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components } from '@/utils'

import groupButton from '@/components/button/group'
import info from '@/components/info'
import form from '@/components/services/payments/form'

function renderTypes(h) {
  return h(
    groupButton,
    {
      props: {
        value: this.proxy.type,
        items: this.types,
        fullWidth: true,
        equalWidth: true
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}
function renderThreshold(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.threshold,
        label: this.getTranslate(`${Services.recurrentPayments}.labels.threshold`),
        hint: this.getTranslate(`${Services.recurrentPayments}.hints.threshold`),
        error: this.localErrors.threshold,
        suffix: this.getTranslate(`currency.${this.globalSettings.billings.currency}.symbol.unicode`),
        maskOptions: integerMaskOptions,
        required: true,
        autofocus: true,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.threshold = event
        }
      }
    }
  )
}
function renderFrequency(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.frequency,
        hint: this.getTranslate(`${Services.recurrentPayments}.labels.frequency`),
        items: this.frequencyItems,
        required: true,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.frequency = event
        }
      }
    }
  )
}
function renderFieldByType(h) {
  switch (this.proxy.type) {
    case RECURRENT_PAYMENTS_TYPES.threshold: return renderThreshold.call(this, h)
    case RECURRENT_PAYMENTS_TYPES.frequency: return renderFrequency.call(this, h)
  }
}
function renderTypesContent(h) {
  return h(
    'div',
    {
      class: `${Services.recurrentPayments}-form__type`
    },
    [
      renderTypes.call(this, h),
      renderFieldByType.call(this, h)
    ]
  )
}

function renderPaymentsForm(h) {
  return h(
    form,
    {
      props: {
        value: this.proxy,
        OwnerId: this.OwnerId
      },
      on: {
        input: event => {
          this.proxy = event
        },
        validation: event => {
          this.formValidation = event
        }
      }
    }
  )
}

function renderHint(h) {
  if (this.isNew) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.recurrentPayments}.hints.redirect`),
          color: Colors.primary
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.recurrentPayments}-form`
    },
    [
      renderTypesContent.call(this, h),
      renderPaymentsForm.call(this, h),
      renderHint.call(this, h)
    ]
  )
}
